import React, { useEffect } from 'react';

import { DropdownController } from 'components/form/Dropdown';
import { Form, FormGroup, Input, Error } from 'components/checkout';
import { COUNTRY_USA, COUNTRY_CANADA } from 'utils/constants';

import { FavoritesDropdown } from './FavoritesDropdown';
import { AddToFavoritesButton } from './AddToFavoritesButton';
import { countries, usaStates, canadaStates } from './options';
import { setupCanadaPost } from './canadaPost';

const AddressForm = ({ formController, accountAddresses, refetch }) => {
  const { register, control, watch, errors } = formController;

  const country = watch('country');
  const favorite = watch('id');
  const isCanada = country === COUNTRY_CANADA;
  const isUsa = country === COUNTRY_USA;

  const handleAddressChange = () => {
    formController.setValue('id', ''); //Reset favorites dropdown
  };

  useEffect(() => {
    setupCanadaPost(formController);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form>
      <FavoritesDropdown
        formController={formController}
        accountAddresses={accountAddresses}
        refetch={refetch}
      />
      <Error>{errors.address1 && errors.address1.message}</Error>
      <FormGroup>
        <label>Address</label>
        <div>
          <Input
            id="address1"
            name="address1"
            maxLength={40}
            error={errors.address1}
            onChange={handleAddressChange}
            ref={register}
            autoComplete="no" //Chrome ignores 'off' or 'false', need to user a random string
          />
        </div>
      </FormGroup>
      <Error>{errors.address2 && errors.address2.message}</Error>
      <FormGroup>
        <label>Address 2</label>
        <div>
          <Input
            name="address2"
            maxLength={40}
            error={errors.address2}
            onChange={handleAddressChange}
            ref={register}
          />
        </div>
      </FormGroup>
      <Error>{errors.city && errors.city.message}</Error>
      <FormGroup>
        <label>City</label>
        <div>
          <Input
            name="city"
            maxLength={60}
            error={errors.city}
            onChange={handleAddressChange}
            ref={register}
          />
        </div>
      </FormGroup>
      <Error>{errors.state && errors.state.message}</Error>
      <FormGroup>
        <label>State/Province/Region</label>
        <div>
          {isUsa || isCanada ? (
            <DropdownController
              control={control}
              name="state"
              onChange={handleAddressChange}
              options={isUsa ? usaStates : canadaStates}
              defaultText="State/Province/Region"
            />
          ) : (
            <Input name="state" maxLength={60} onChange={handleAddressChange} ref={register} />
          )}
        </div>
      </FormGroup>
      <Error>{errors.zipcode && errors.zipcode.message}</Error>
      <FormGroup>
        <label>Zip/Postal Code</label>
        <div>
          <Input
            name="zipcode"
            maxLength={60}
            error={errors.zipcode}
            onChange={handleAddressChange}
            ref={register}
          />
        </div>
      </FormGroup>
      <Error>{errors.country && errors.country.message}</Error>
      <FormGroup>
        <label>Country</label>
        <div>
          <DropdownController
            control={control}
            name="country"
            onChange={handleAddressChange}
            options={countries}
          />
        </div>
      </FormGroup>
      <AddToFavoritesButton
        formController={formController}
        disabled={!!favorite}
        afterAddAddress={refetch}
      />
    </Form>
  );
};

export { AddressForm };
